import classNames from 'classnames';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './NoHais.less';

interface OwnProps {
  labelKey: string;
}

type Props = OwnProps;

export const NoHais: React.FC<Props> = ({labelKey, ...extraProps}) => {
  return (
    <div className={styles.dlNoHaisWrapper} {...extraProps}>
      <i
        className={classNames('fas fa-circle-exclamation', styles.dlNoHaisIcon)}
      />
      <div className={styles.dlNoHaisMessage}>
        <FormattedMessage id={labelKey} />
      </div>
    </div>
  );
};
